import { getCodesDropdown } from 'api/accessCode'
import { getPathways } from 'api/pathways'
import { getUser } from 'api/users'
import PageTitle from 'components/page/PageTitle'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import { useCallback, useState } from 'react'
import { useQuery } from 'react-query'
import { UserType } from 'types'
import { UserDetailsCaregiverForm } from '../UserDetailsCaregiverForm/UserDetailsCaregiverForm'
import { UserHistory } from '../UserHistory/UserHistory'
import { UserTraineeDetails } from '../UserTraineeDetails/UserTraineeDetails'

export function UserDetails({ userId }: { userId: number }) {
  const [needUpdateHistory, setNeedUpdateHistory] = useState(false)
  const userQuery = useQuery(['user', userId], () => getUser({ id: userId }))
  const pathways = useQuery(['pathways'], () => getPathways())
  const accessCodes = useQuery('access-codes', () => getCodesDropdown({ onlyValid: true }))

  const handleAfterUpdate = useCallback(() => {
    userQuery.refetch()
  }, [userQuery])

  const handleResetNeedUpdateHistory = useCallback(() => {
    setNeedUpdateHistory(false)
  }, [])

  if (userQuery.isFetching || pathways.isLoading) {
    return <LoadingPlaceholder />
  }

  if (!userQuery.data || !pathways.data) {
    return <div>Something went wrong</div>
  }

  const isCaregiver = userQuery.data.data.type.includes(UserType.CAREGIVER)

  return (
    <>
      <PageTitle>Edit User View</PageTitle>

      {isCaregiver ? (
        <>
          <UserDetailsCaregiverForm user={userQuery.data.data} onAfterUpdate={handleAfterUpdate} />

          <UserHistory
            userId={userId}
            pathways={pathways.data}
            needUpdate={needUpdateHistory}
            resetNeedUpdate={handleResetNeedUpdateHistory}
          />
        </>
      ) : (
        <UserTraineeDetails
          userId={userId}
          user={userQuery.data.data}
          pathways={pathways.data}
          accessCodes={accessCodes.data?.data || []}
          onAfterUpdate={handleAfterUpdate}
          needUpdateHistory={needUpdateHistory}
          onResetNeedUpdateHistory={handleResetNeedUpdateHistory}
        />
      )}
    </>
  )
}
